import {Component, OnInit, ViewChild, signal} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BASE_URL } from '../../../config/config';
import { timestampFormat } from '../../../../app/config/moment';
import { AddMasterProductComponent } from './add-master-product/add-master-product.component';
import { DeleteMasterProductComponent } from './delete-master-product/delete-master-product.component';
import { MessagePopupComponent } from '../../bulk-upload/modals/message-popup/message-popup.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MasterdataService } from '../../services/masterdata.service';
import { PaginationComponent } from '../../common/pagination/pagination.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

@Component({
  selector: 'app-master-implants',
  standalone: true,
  imports: [CommonModule,FormsModule,PaginationComponent],
  templateUrl: './master-implants.component.html',
  styleUrls: ['./master-implants.component.scss', '../../../app.component.scss']
})
export class MasterImplantsComponent implements OnInit{
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;

  totalImplantsCount: number = 0;
  public alerts: any = []
  public delete: any = [] 
  public masterType: string = "implants";
  public fileType = ""; 
  public isFile = false;
  public uploadedFile: any;
  public statusType: string = "";
  searchTerm: string = '';
  public statusMessage: string = "";
  public implants: any = []  
  public isDragOver = signal(false);
  public timestampFormat = timestampFormat;
  public bodyparts: any = [];

  public searchInput: string = "";
  public encodedSearchInput: string = "";

  public isSearch = false;
  public isFilter = false;
  public isFilterResult = true;
  public totalPages: number = 0;
  public currentPage: number = 1;
  public paginationData: any;
  public search : any = [];
  public selectedStatus = [];

  public BASE = BASE_URL.URL;

  constructor(private spinnerService: NgxSpinnerService,public dialog: MatDialog, public masterdataService: MasterdataService, public router: Router) { }

  ngOnInit(): void {
    this.getMasterBodyParts();
    this.getMasterImplants(this.search,this.currentPage)
  }

  dropFile(e) {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.fileValidation(file)
    }

    this.isDragOver.set(false);
  }

  dragOverFile(e) {
    e.preventDefault();
    this.isDragOver.set(true);
  }

  dragLeaveFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  browseFile(e){
    e.preventDefault();
    let fileInput: any = document.getElementById("masterimplantswrapper").querySelector('[id="file-input"]');
    if (fileInput) fileInput.click();
  }

  dragEndFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  onFileChange(event){
    event.preventDefault();
    const file = event.target.files[0];
    if (file) {
      this.fileValidation(file);
    }
  }

  onSubmit() {
    this.spinnerService.show(); 
    let formData = new FormData();
    
    formData.append('file', this.uploadedFile);
    let loggedUser = JSON.parse(localStorage.getItem('role'));
    formData.append('warehouse_id', loggedUser.resource_id);

    let token = localStorage.getItem('token');

    fetch(`${this.BASE}/bulk-stocks/master/upload/${this.masterType}`, {
      method: 'POST', 
      body: formData,
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).then((response)=>{
      if (response.status === 200) {
        if (response.headers.get('Content-Type') === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
          const uploadeEntries = response.headers.get('Uploaded-Entries');
          const invalidEntries = response.headers.get('Invalid-Entries');
          let fileName = `${this.masterType}-${this.fileType}-error`;
          return response.blob().then((blobContent) => {
            this.getMasterImplants(this.search,this.currentPage);
            this.openDialogBrowse(blobContent, uploadeEntries, invalidEntries, fileName);
          })
        }else if(response.headers.get('Content-Type') === "application/json"){
          this.statusType = 'success';
          this.statusMessage = `The ${this.uploadedFile.name} data has been uploaded successfully!`;
          this.showWarningToast();
          this.getMasterImplants(this.search,this.currentPage);
        }
      }

      if (response.status === 204) {
        this.statusType = 'success';
        this.statusMessage = 'Nothing to update';
        this.showWarningToast();
      }

      if (response.status === 422) {
        this.statusType = 'error';
        this.statusMessage = 'Unprocessable Content';
        this.showWarningToast();
        
        response.json().then((jsonData) =>{
          if (!jsonData.data.excluded) {
            this.statusType = 'error';
            this.statusMessage = 'Error: The uploaded file and uploaded for doesn’t match';
            this.showWarningToast();
          }
        })
      }

      if (response.status === 401) {
        localStorage.clear();
        this.router.navigateByUrl('/login');
        this.spinnerService.hide();
        return;
      }

      if (response.status === 500) {
        this.statusType = 'error';
        this.statusMessage = `Oops, Something went wrong!`;
        this.showWarningToast();
      }
    })
    .catch((err)=>{
      this.spinnerService.hide();
      console.log('err', err);
    }).finally(()=>{
      this.spinnerService.hide();
    })
  }

  fileValidation(file){
    const validFileTypes = ['csv', 'xlsx', 'xls'];
    let ext = file.name.substring(file.name.lastIndexOf('.') + 1);
    if (validFileTypes.includes(ext)) {
      this.isFile = true;
      this.fileType = ext;
      this.uploadedFile = file;
    }else{
      this.statusType = 'error';
      this.statusMessage = `File format is invalid. Only Excel and CSV formats are allowed.`;
      this.showWarningToast();
    }
  }

  resetFile(){
    this.isFile = false;
    this.fileType = '';
  }

  showWarningToast(){
    const toastContainer = document.getElementById('warning-toast');

    if (toastContainer) {
      setTimeout(function() {
        toastContainer.classList.add('show');
      }, 100);
      setTimeout(function() {
        toastContainer.classList.remove('show');
      }, 5000);
    }
  }

  openDialogBrowse(blob, uploadeEntries: string, invalidEntries: string, fileName: string): void {
    const dialogRef = this.dialog.open(MessagePopupComponent, {
      data: {
        blob,
        uploadeEntries, 
        invalidEntries,
        fileName
      }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  openEditDialog(implants:any): void {

    const dialogRef = this.dialog.open(AddMasterProductComponent, {
      disableClose: true,
      data: {
        type: "edit",
        item: implants,
        bodyparts: this.bodyparts
      }
    }).afterClosed().subscribe(()=>{
      this.getMasterBodyParts();
      this.getMasterImplants(this.search,this.currentPage);
    });
  } 

  openDialog(implants): void {
    this.getMasterBodyParts();
    const dialogRef = this.dialog.open(AddMasterProductComponent, {
      data:{
        type: "add",
        bodyparts: this.bodyparts
      }
    });
    dialogRef.afterClosed().subscribe(()=>{
      this.getMasterBodyParts(); 
      this.getMasterImplants(this.search,this.currentPage);
    });
  } 
 
  openDeleteDialog(item: any): void {
    const dialogRef = this.dialog.open(DeleteMasterProductComponent, {
    }).afterClosed().subscribe(result=>{
      if(result == "confirm"){
        this.masterdataService.deleteBodyParts(item.id, "implants").subscribe((res:any)=>{
          if(res && res.success){
            this.getMasterBodyParts(); 
            this.getMasterImplants(this.search,this.currentPage);
          }
        })
      } 
    }); 
  } 

  getMasterBodyParts(){
    this.masterdataService.getMasterBodyParts(this.search,this.currentPage).subscribe((res)=>{
      if (res.data && res.data.data) {
        this.bodyparts = res.data.data.map(item => {return {id:item.id, value:item.name}});
      }
    });
  }
   
  getMasterImplants(search: string = "", currentPage: number){
    this.masterdataService.getMasterImplants(search, currentPage).subscribe((res)=>{
      if (res.data) {
        this.implants = res.data.data;
        this.paginationData = res.data.data;
        this.totalImplantsCount =  res.data.total;
        this.paginationData.totalPage = Math.ceil(res.data.total / 15);
        console.log(this.paginationData, " paginationData");
      }
    });
  } 

  getQueryPage(event:any){
    console.log(event);
    this.currentPage = event;
    this.getMasterImplants(this.search,this.currentPage)
  }

  onSearchSubmit(){
    if (this.searchInput !== "") {
      this.isSearch = true;
      if (this.isFilter) { 
        this.isFilter = false; 
        this.isFilterResult = true;
      }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      this.getMasterImplants(this.encodedSearchInput, this.currentPage);
    }
  }
 
  downloadBulkUploadTemplate(implants) {
    this.masterdataService.downloadBulkUploadTemplate(implants);
  }

  searchByImplantsName(): void {
    this.implants = this.implants.filter((implants: any) =>
      implants.name.toLowerCase().includes(this.searchTerm.toLowerCase()) 
    );
  }
  
  reset(event: Event){
    event.preventDefault();
    if (this.isSearch || this.isFilter) {
      this.encodedSearchInput = "";
      this.selectedStatus = [];
      this.isSearch = false;
      this.isFilter = false;
      this.isFilterResult = true;
      this.getMasterImplants(this.encodedSearchInput, this.currentPage);
    }
  }

}
